import Poi from '@/components/sl-amap/components/amap-poi'
import { getStaticPath } from '@/util/request'
import { throttle } from '@/util'
import { wgs2gcj } from '@/util/map/proj'
import Event from '@/util/proto/event'

class carMapPoi extends Event{
  constructor(map , moveMode = false) {
    super()

    this.visible = true
    this.lastFocus = null
    this.poiTpl = '<div class="sl-amap-poi-span {statusIcon}" data-id="{id}" title="{displayLabel}">{displayLabel}<i /></div>'
    this.poiManager = new Poi(map, {
      poiTpl: this.poiTpl,
      size: [72, 42],
      offset: [-16, -37],
      moveMode:moveMode,
      handlers:{
        open:(data)=>{
          this.trigger('pointClick' , {data})
        }
      }
    })

    map.on('moveend', this.update)

    // map.on('zoomstart', this.beforeZoom)
    map.on('zoomend', this.update)
    map.on('resize', this.update)
  }

  setData(data) {
    this.poiManager.load(data)
  }

  hide() {
    this.visible = false
  }

  show() {
    this.visible = true
  }

  update(){
    //this.fetchCompany(this.poiManager.getBounds(true))
  }

  focus(id){
    if(this.lastFocus){
      let el = document.querySelector('.sl-amap-poi-span.focus')
      el.className =  el.className.replace('focus','')
    }

    if(id){
      let el = document.querySelector('.sl-amap-poi-span[data-id="'+id+'"]')
      el.className = el.className += ' focus'
      this.poiManager.focus(id)
    }

    this.lastFocus = id
  }
}


export default carMapPoi
